<script>
//TODO: centralize location, time and canteen settings!
import Modal from '@/components/atoms/Modal'
import InputSelect from '@/components/atoms/inputlib/components/InputSelect'
import RadioLine from '@/components/molecules/input/RadioLine'
import DateSelector from '@/components/organism/DateSelector'
import date from '@/modules/mixins/date'
import Vue from 'vue'

export default {
    name: 'ModalDeliveryTime',
    components: { DateSelector, InputSelect, RadioLine, Modal },
    mixins: [date],
    mounted() {
        Vue.prototype.$time = {}

        this.$nextTick(() => {
            Vue.prototype.$time = {
                open: (calculate = false) => {
                    this.open(calculate)
                },
                schedule: (calculate = false) => {
                    this.asap = false
                    this.setLater()
                    this.open(calculate)
                },
                asap: () => {
                    this.asap = true
                    this.setTime()
                    this.confirm(false)
                },
                // tasks#170: an automatic switch away from an ASAP that became unavailable commits the first offered
                // window, so the unavailable option is not left selected even if the customer cancels the modal.
                // Resolves false (nothing changed) when the periods offer no window: an empty time is never selected
                scheduleFirstOffered: async () => {
                    const firstOffered = this.firstOfferedTime()
                    if (!firstOffered) return false
                    this.asap = false
                    this.setTime(firstOffered)
                    await this.setDeliveryTime()
                    return true
                },
            }
        })
        this.initDeliveryTime(this.$route.query)
    },
}
</script>

<template lang="pug">
modal(ref="ModalDeliveryTime" @close="cancel" :closable="false" :scroll="!asap")
    template(v-slot:header)
        .modal-header-text {{$t('details.when')}}
    template(v-slot:body)
        .alert.alert-info.mb-0(v-if="allowance")
            icon.mr-2(icon="fa-solid fa-exclamation-circle")
            template(v-if="noTimeLimit || dontApplyTimeRules") {{$t('details.allowance_selected_no_time_limit', {allowance: allowance.name})}}
            template(v-else) {{$t('details.allowance_selected', {allowance: allowance.name})}}
        radio-line(v-model="asap" :disabled="!asapEnabled" @input="setValue" :data="true") {{$t('details.asap')}}
        radio-line(v-model="asap" @input="setValue" :data="false") {{$t('details.schedule_later')}}
        date-selector(
            v-model="value"
            v-show="!asap"
            :allowance="allowance"
            :restaurant="activeRestaurant"
            :days="days"
            :times="times"
            :noLimit="noTimeLimit"
            @input="setTime")
    template(v-slot:footer)
        button.btn.btn-secondary(@click="cancel(true)") {{$t('base.cancel')}}
        button.btn.btn-primary(@click="confirm") {{$t('details.confirm_time')}}
</template>
